<template>
	<div class="policies width">
		<aside>
			<!-- 本会动态 -->
			<div class="directory">
				<p><span>法律法规</span></p>
				<ul>
					<li @click="$router.replace('/policies/lawRegulation')">
						<span>法律</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="$router.replace('/policies/regulation')">
						<span>行政法规</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="$router.replace('/policies/departmentalRegulation')">
						<span>部门规章</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="$router.replace('/policies/interpretation')">
						<span>司法解释</span>
						<i class="el-icon-arrow-right"></i>
					</li>
					<li @click="$router.replace('/policies/internationalTreaty')">
						<span>国际条约</span>
						<i class="el-icon-arrow-right"></i>
					</li>
				</ul>
			</div>
		</aside>
		
		<div class="content">
			<router-view />
		</div>
		

	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		mounted() {},
		methods: {
			
		},
	};
</script>
<style>
	.el-pagination {
		text-align: right;
	}

	.el-divider--horizontal {
		margin: 10px 0;
	}
</style>
<style scoped>
	.policies {
		margin: 20px auto;
		margin-bottom: 100px;
		display: flex;
	}

	aside {
		width: 15%;
	}

	.directory p,
	.contact p {
		border-bottom: 1px solid #ddd;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.directory p span,
	.contact p span {
		display: inline-block;
		padding: 7px 10px;
		font-weight: bold;
		border-bottom: 2px solid #016fb8;
	}

	.directory ul {
		margin-top: 10px;
	}

	.directory ul li span {
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.directory ul li span:hover {
		color: #016fb8;
		font-weight: bold;
		cursor: pointer;
	}

	.directory ul li {
		background: #ddd;
		margin-top: 4px;
		padding: 10px;
		color: gray;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content {
		width: 80%;
		margin-top: 27px;
		margin-left: 30px;
	}
</style>
